import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { CategoryDetailsComponent } from 'src/app/templates/featured-category/component/category-details/category-details.component';
import { ErrorPageComponent } from 'src/app/templates/error-page/error-page.component';
import { ProductDetailsComponent } from 'src/app/templates/featured-product/component/product-details/product-details.component';
import { BrowserService } from 'src/_lib/service/browser.service';
import { inject } from '@angular/core';

export const placeholderComponentResolver: ResolveFn<any> = (route, state) => {
  const browser = inject(BrowserService);
  const id: string = route.params['id'];
  const pattern: boolean = /^[0-9]*$/.test(id.slice(1, id?.length));

  if (id?.length > 1 && id.startsWith('p') && pattern) {
    // localStorage is only available in the browser — skip on the server.
    // CategoryDetailsComponent reads the key as a fallback, but also has a
    // URL-param fallback so SSR renders correctly without it.
    if (browser.isBrowser) {
      browser.localStorage?.setItem('selectedproductkey', String(id.slice(1)));
      browser.localStorage?.removeItem('selectedcategorykey');
    }
    return of(ProductDetailsComponent);
  }
  else if (id?.length > 1 && id.startsWith('c') && pattern) {
    if (browser.isBrowser) {
      browser.localStorage?.setItem('selectedcategorykey', String(id.slice(1)));
      browser.localStorage?.removeItem('selectedproductkey');
    }
    return of(CategoryDetailsComponent);
  }
  else {
    return of(ErrorPageComponent);
  }
}